import { MahiData } from "../../service/forms/config-generics/employment";

export function getEmploymentLines({ mahi, pūteaMahi }: MahiData) {
    return [
        { heading: "Employment" },
        { label: "Employer", text: mahi },
        { label: "Income", text: pūteaMahi },
    ];
}